// extracted by mini-css-extract-plugin
export var cardTitle = "_cc-1";
export var commentBubble = "_cc-e";
export var commentForm = "_cc-a";
export var commentInput = "_cc-b";
export var commentLabel = "_cc-d";
export var commentPrompt = "_cc-9";
export var csatCard = "_cc-0";
export var feedbackSection = "_cc-7";
export var starDisabled = "_cc-6";
export var starEmpty = "_cc-5";
export var starFilled = "_cc-4";
export var starWrapper = "_cc-3";
export var starsContainer = "_cc-2";
export var submittedComment = "_cc-c";
export var thankYouText = "_cc-8";